import { Routes } from '@angular/router';
import { PlanningComponent } from './planning.component';

export const planningRoutes: Routes = [
    {
        path:       '',
        component:  PlanningComponent
    },
];
